import Vue from "vue";
import Vuex from "vuex";
import macroAnimations from "@/assets/json-data/macroAnimations.js";
let macroAnimationsData = macroAnimations();
import microAnimations from "@/assets/json-data/microAnimations.js";
import ambientAnimations from "@/assets/json-data/ambientAnimations.js";
import moduleMacroAnimations from "./modules/moduleMacroAnimations";
import moduleMicroAnimations from "./modules/moduleMicroAnimations";
import objBuild from "./modules/moduleObjBuilder";
import textBox from "./modules/moduleTextBox";
import panZoom from "./modules/modulePanZoom";
import productBar from "./modules/moduleProductBar";
import audio from "./modules/moduleAudio";
import filter from "./modules/moduleFilter";
import moduleAmbientAnimations from "./modules/moduleAmbientAnimations";
import logos from "./modules/moduleLogos";
import analytics from "./modules/moduleAnalytics";
import landingPage from "./modules/moduleLandingPage";
import swiper from "./modules/moduleSwiper";
import loader from "./modules/moduleLoader";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    macroAnimations: [],
    microAnimations: [],
    ambientAnimations: []
  },
  mutations: {
    setMacroAnimations(state, payload) {
      state.macroAnimations = payload;
    },
    setMicroAnimations(state) {
      state.microAnimations = microAnimations;
    },
    setAmbientAnimations(state) {
      state.ambientAnimations = ambientAnimations;
    }
  },
  actions: {
    generateMacroAnimationNumId({ commit }) {
      let tempArr = macroAnimationsData.map((animation, i) => {
        return { ...animation, numId: i };
      });
      commit("setMacroAnimations", tempArr);
    },
    generateAmbientAnimation({ commit }) {
      let tempArr = ambientAnimations.map((animation, i) => {
        return { ...animation, numId: i };
      });
      commit("setAmbientAnimations", tempArr);
    }
  },
  modules: {
    objBuild,
    moduleMacroAnimations,
    moduleMicroAnimations,
    moduleAmbientAnimations,
    textBox,
    panZoom,
    productBar,
    audio,
    filter,
    logos,
    analytics,
    landingPage,
    swiper,
    loader
  }
});
